import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { X, Sparkles, ExternalLink } from 'lucide-react';
import styles from './BookDemoModal.module.css';

const CALENDLY_URL = "https://calendly.com/sanjaysoni-provaantech/vendor-empanelment-discussion-provaantech";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

const BookDemoModal = ({ isOpen, onClose }) => {
  const [isIframeLoading, setIsIframeLoading] = useState(true);
  useEffect(() => {
    const handleCalendlyEvent = async (e) => {
      if (e.origin === "https://calendly.com" && e.data && e.data.event === "calendly.event_scheduled") {
        console.log("Calendly event scheduled:", e.data.payload);
        const payload = e.data.payload || {};
        const invitee = payload.invitee || {};
        const event = payload.event || {};

        const name = invitee.name || (invitee.first_name ? `${invitee.first_name} ${invitee.last_name || ''}`.trim() : 'Calendly Booking');
        const email = invitee.email || 'N/A';
        const date = event.start_time || new Date().toISOString();
        const phone = invitee.text_reminder_number || invitee.phone || 'Calendly Sync';
        const message = `Scheduled directly via Calendly Widget`;

        try {
          const res = await fetch(`${API_BASE_URL}/api/v1/demo`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              name,
              email,
              phone,
              message,
              date,
              turnstileToken: 'calendly-verified-token'
            })
          });

          if (res.ok) {
            toast.success('Calendly booking synced to Admin Dashboard!');
          }
        } catch (err) {
          console.error('Failed to sync Calendly event to backend:', err);
        }
      }
    };

    window.addEventListener('message', handleCalendlyEvent);
    return () => window.removeEventListener('message', handleCalendlyEvent);
  }, []);

  if (!isOpen) return null;

  const embedUrl = `${CALENDLY_URL}?embed_domain=${encodeURIComponent(window.location.hostname || 'localhost')}&embed_type=Inline&primary_color=3b82f6`;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modalCard} onClick={(e) => e.stopPropagation()}>
        <div className={styles.glowGradient} />

        <div className={styles.header}>
          <div>
            <div className={styles.badgeTag}>
              <Sparkles size={14} /> Schedule Meeting via Calendly
            </div>
            <h2 className={styles.headerTitle}>Book a Discovery Call</h2>
            <div className={styles.headerSub}>
              Select a date & time slot directly from the live calendar below.
            </div>
          </div>

          <div className={styles.headerActions}>
            <a 
              href={CALENDLY_URL} 
              target="_blank" 
              rel="noopener noreferrer" 
              className={styles.externalBtn}
              title="Open Calendly in new tab"
            >
              Open in new tab <ExternalLink size={14} />
            </a>
            <button onClick={onClose} className={styles.closeBtn} aria-label="Close">
              <X size={20} />
            </button>
          </div>
        </div>

        <div className={styles.iframeContainer} style={{ position: 'relative', minHeight: '550px' }}>
          {isIframeLoading && (
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: '#1e293b', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '20px', zIndex: 10 }}>
              <style>{`
                @keyframes spin-modal-loader {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}</style>
              <div style={{ width: '40px', height: '40px', borderRadius: '50%', border: '3px solid rgba(59, 130, 246, 0.15)', borderTopColor: '#3b82f6', animation: 'spin-modal-loader 1s linear infinite' }} />
              <div style={{ color: '#94a3b8', fontSize: '0.9rem', fontWeight: 500, fontFamily: '"Inter", system-ui, sans-serif' }}>Loading Calendar...</div>
            </div>
          )}
          <iframe
            src={embedUrl}
            onLoad={() => setIsIframeLoading(false)}
            width="100%"
            height="100%"
            frameBorder="0"
            title="Schedule Discussion via Calendly"
            style={{ border: 'none', width: '100%', height: '100%', minHeight: '550px', display: isIframeLoading ? 'none' : 'block' }}
          />
        </div>
      </div>
    </div>
  );
};

export default BookDemoModal;
